import { RunStatus } from "@/constants/flows";
import { toSentenceCase } from "js-convert-case";
import { CheckCircle, XCircle, Loader, PauseCircle, Clock } from "lucide-react";

interface Props {
  status: RunStatus;
  statusOverride?: string;
}

const statusStyles: Record<
  RunStatus,
  { bg: string; text: string; ring: string; icon: JSX.Element }
> = {
  pending: {
    bg: "bg-yellow-300/10",
    text: "text-yellow-500",
    ring: "ring-yellow-300/20",
    icon: <Clock className="h-3 w-3 text-yellow-500" />,
  },
  running: {
    bg: "bg-blue-400/10",
    text: "text-blue-400",
    ring: "ring-blue-400/30",
    icon: <Loader className="h-3 w-3 text-blue-400 animate-spin" />,
  },
  waiting: {
    bg: "bg-gray-400/10",
    text: "text-gray-400",
    ring: "ring-gray-400/20",
    icon: <PauseCircle className="h-3 w-3 text-gray-400" />,
  },
  completed: {
    bg: "bg-green-500/10",
    text: "text-green-400",
    ring: "ring-green-500/20",
    icon: <CheckCircle className="h-3 w-3 text-green-400" />,
  },
  failed: {
    bg: "bg-red-400/10",
    text: "text-red-400",
    ring: "ring-red-400/20",
    icon: <XCircle className="h-3 w-3 text-red-400" />,
  },
  skipped: {
    bg: "bg-gray-400/10",
    text: "text-gray-400",
    ring: "ring-gray-400/20",
    icon: <PauseCircle className="h-3 w-3 text-gray-400" />,
  },
};

export const StatusBadge = ({ status, statusOverride }: Props) => {
  const style = statusStyles[status];

  return (
    <span
      className={`inline-flex items-center rounded-md ${style.bg} px-2 py-1 text-xs font-medium ${style.text} ring-1 ring-inset ${style.ring}`}
    >
      {style.icon}
      <span className="ml-1">
        {statusOverride ? statusOverride : toSentenceCase(status)}
      </span>
    </span>
  );
};
